import { Navigate, Route, Routes } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $profileStore, $remoteConfigStore } from '@lib/store';
import { RoutePaths } from '@shared/utils';
import { UserType } from '@shared/api';
import {
  AccountPage,
  AccountsPage,
  AlertsPage,
  CardPage,
  CardsPage,
  DashboardPage,
  ErrorPage,
  IntegrationPage,
  IntegrationsPage,
  IntegrationsCallbackPage,
  MessageCenterPage,
  PaymentBetweenAccountsPage,
  PaymentCardSettlementPage,
  PaymentOtherBankPage,
  PaymentsPage,
  ProfilePage,
  RecipientPage,
  RecipientNewPage,
  ReportsPage,
  StatementsPage,
  TransactionPage,
  UserPage,
  UserManagementPage,
  RewardsPage,
} from '@pages';

export const Private = () => {
  const profileStore = useUnit($profileStore.store);

  return (
    <Routes>
      <Route path={RoutePaths.alerts.path} element={<AlertsPage />} />
      <Route path={RoutePaths.dashboard.path} element={<DashboardPage />} />
      <Route path={RoutePaths.accounts.path} element={<AccountsPage />} />
      <Route path={RoutePaths.account.path} element={<AccountPage />} />
      <Route path={RoutePaths.accountTransaction.path} element={<TransactionPage />} />
      <Route path={RoutePaths.payments.path} element={<PaymentsPage />} />
      <Route path={RoutePaths.paymentsOther.path} element={<PaymentOtherBankPage />} />
      <Route path={RoutePaths.paymentsCard.path} element={<PaymentCardSettlementPage />} />
      <Route path={RoutePaths.paymentsInsignia.path} element={<PaymentBetweenAccountsPage />} />
      <Route path={RoutePaths.paymentsRecipient.path} element={<RecipientPage />} />
      <Route path={RoutePaths.paymentNewRecipients.path} element={<RecipientNewPage />} />
      <Route path={RoutePaths.cards.path} element={<CardsPage />} />
      <Route path={RoutePaths.card.path} element={<CardPage />} />
      {$remoteConfigStore.events.getValue('RewardsPage', 'boolean') &&
        profileStore.data?.accumulateRewards &&
        profileStore.data?.userType === UserType.Admin && <Route path={RoutePaths.rewards.path} element={<RewardsPage />} />}
      <Route path={RoutePaths.users.path} element={<UserManagementPage />} />
      <Route path={RoutePaths.user.path} element={<UserPage />} />
      <Route path={RoutePaths.statements.path} element={<StatementsPage />} />
      <Route path={RoutePaths.reports.path} element={<ReportsPage />} />
      <Route path={RoutePaths.callback.path} element={<IntegrationsCallbackPage />} />
      <Route path={RoutePaths.integrations.path} element={<IntegrationsPage />} />
      <Route path={RoutePaths.integration.path} element={<IntegrationPage />} />
      <Route path={RoutePaths.messages.path} element={<MessageCenterPage />} />
      <Route path={RoutePaths.profile.path} element={<ProfilePage />} />
      <Route path={RoutePaths.error.path} element={<ErrorPage />} />
      <Route path={RoutePaths.signup.path} element={<Navigate to={RoutePaths.dashboard.onNavigate()} replace />} />
      <Route path={RoutePaths.success.path} element={<Navigate to={RoutePaths.dashboard.onNavigate()} replace />} />
      <Route path='*' element={<Navigate to={RoutePaths.error.onNavigate()} replace />} />
    </Routes>
  );
};
